'use client';

import { ErrorAlert } from '@venienergygroup/shared-components';
import { SystemMessage, SystemMessageLogLevel } from '@/types/api/systemMessages';
import { IncidentBanner } from '@venienergygroup/shared-components/client';
import { Suspense, use } from 'react';

type Props = { messagesPromise: Promise<SystemMessage[]>; filter?: 'error' | 'other' };

const VARIANT_MAP: Record<SystemMessageLogLevel, 'error' | 'warning' | 'info'> = {
  Error: 'error',
  Warning: 'warning',
  Information: 'info',
};

const LoginIncidentBannerComponent = ({ messagesPromise, filter }: Props) => {
  const allMessages = use(messagesPromise);

  const messages =
    filter === 'error'
      ? allMessages.filter((msg) => msg.logLevelId === 'Error')
      : filter === 'other'
        ? allMessages.filter((msg) => msg.logLevelId !== 'Error')
        : allMessages;

  if (messages.length === 0) return null;

  return (
    <div>
      {messages.map((msg) =>
        msg.logLevelId === 'Error' ? (
          <IncidentBanner
            key={msg.id}
            message={msg.message}
            variant={VARIANT_MAP[msg.logLevelId]}
          />
        ) : (
          <div key={msg.id} className="flex w-96 flex-col pt-2">
            <ErrorAlert variant={VARIANT_MAP[msg.logLevelId]} title={msg.logLevelId}>
              {msg.message}
            </ErrorAlert>
          </div>
        ),
      )}
    </div>
  );
};

const LoginIncidentBanner = (props: Props) => (
  <Suspense fallback={null}>
    <LoginIncidentBannerComponent {...props} />
  </Suspense>
);

export default LoginIncidentBanner;
